import React, { Component } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import configData from "../config.json";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

export default class Mckyc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      requestId: sessionStorage.getItem("proposalrequest_Id"),
      isLoading: true,
      proposal_no: sessionStorage.getItem("proposal_no"),
      id_type: "",
      id_num: "",
      identicationtype: "",
      aadharNumber: ["", "", ""],
      proposer_fname: "",
      proposer_lname: "",
      gender: "",
      doc_type: "",
      dob: null,
      startDate: new Date(),
      otp: ["", "", "", "", "", ""],
      showOtp: false,
      showVerification: false,
      showOtpInput: false,
      isCKYCdone: false,
      ispanSubmitting: false,
      isAadhaarSubmitting: false,
      isAadhaarOTPSubmitting: false,
      isOVDSubmitting: false,
      isOVDVerified: false,
    };
  }

  Handlepaymentgateway = (e) => {
    if (e) e.preventDefault();

    const jsonData = {
      payment_mode: "onlinePayment",
      online_payment_mode: "UPI",
      payer_type: "Customer",
      product_code: 3187,
      payer_id: "",
      payer_pan_no: this.state.proposer_pan,
      payer_name: `${this.state.proposer_fname} ${this.state.proposer_lname}`,
      payer_relationship: "",
      email: this.state.proposer_email,
      office_location_code: 90101,
      deposit_in: "Bank",
      pan_no: this.state.proposer_pan,
      payment_id: [sessionStorage.getItem("payment_id")],
      returnurl: "https://dev-app.apnapolicy.co.in/mpolicydownload",
    };

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 362);
    formData.append("savedata", "yes");
    formData.append("jsonData", JSON.stringify(jsonData));

    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          sessionStorage.setItem("proposalPaymentrequest_Id", data.requestId);
          if (data.data.message_txt) {
            toast.success(data.data.message_txt);
          }
          if (data.data.status && data.data.status < 0) {
            const errorMessage =
              data.data.message_txt || "Unknown error occurred.";
            toast.error(errorMessage);
            return; // Stop further processing
          }
          try {
            if (data.data?.data) {
              const innerData = JSON.parse(data.data.data); // ✅ safely parse
              const paymentUrl = innerData.url;

              if (paymentUrl) {
                window.location.href = paymentUrl;
              } else {
                toast.error("Payment URL not found.");
              }
            } else {
            }
          } catch (err) {
          }
        } else {
        }
      })
      .catch((error) => {

      });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.success(msg);
    }
  };
  handleChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      id_type: fieldValue,
    });
  };
  handlePanChange = (e) => {
    const { name, value } = e.target;
    if (name === "id_num") {
      const cleanedValue = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      this.setState({ id_num: cleanedValue });
    }
  };
  handleidenticationtypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      identicationtype: fieldValue,
    });
  };
  handleDChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      // Assuming you want to update the 'dob' state with the selected date
      this.setState({
        dob: formattedDate,
        startDate: new Date(),
      });
    }
  };

  validateForm = () => {
    const { id_num, id_type } = this.state;
    let formIsValid = true;

    if (!id_type) {
      toast.info("Please select an Identity Proof");
      formIsValid = false;
    } else if (!id_num) {
      toast.info("*Please Enter PAN Number.");
      formIsValid = false;
    } else if (id_type === "PAN") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (!panRegex.test(id_num.toUpperCase())) {
        toast.info("*Invalid PAN Number format. Ex: ABCDE1234F");
        formIsValid = false;
      }
    }

    return formIsValid;
  };
  //Pan submit
  HandlePansubmit = (e) => {
    e.preventDefault();

    const jsonData = {
      id_num: this.state.id_num,
      id_type: "PAN",
      proposal_no: this.state.proposal_no,
      // ckyc_consent_take: true,
    };
    this.setState({ ispanSubmitting: true });
    const jsonData1 = JSON.stringify(jsonData);
    if (this.validateForm()) {
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("jsonData", JSON.stringify(jsonData1));
      formData.append("requestId", sessionStorage.proposalrequest_Id);
      // formData.append("ckyc_consent_taken", true);
      formData.append("integId", 333);
      formData.append("savedata", "yes");
      fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
        // Enter your IP address here

        method: "POST",
        //headers :{ 'Content-Type' : 'application/json'},
        mode: "cors",
        body: formData, // body data type must match "Content-Type" header
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.success);
          if (data.status === "success") {
            sessionStorage.setItem("panrequestID", data.requestId);
            setTimeout(() => {
              this.handlerequestcall();
              this.setState({ ispanSubmitting: false });
            }, 20000);
          } else {
            this.setState({ ispanSubmitting: false });
          }
        });
    }
  };
  handlerequestcall = (e) => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 333);
    formData.append("requestId", sessionStorage.panrequestID);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.data?.data;
        if (responseData?.req_id) {
          sessionStorage.setItem("req_id", responseData.req_id);
          sessionStorage.setItem("requestId", responseData.panrequestID);
          this.setState({ showVerification: true });
        }
        this.setState({ showVerification: true });
      })
      .catch((err) => {

      });
  };
  //pan submiision over//
  //OVD
  handleOVDsubmitClick = (e) => {
    e.preventDefault();
    const { id_num, id_type } = this.state;
    var formData = new FormData();
    formData.append("id_num", id_num);
    formData.append("id_type", id_type);
    formData.append("proposal_no", sessionStorage.proposal_no);
    formData.append("integId", 327);
    formData.append("requestId", 1746292838);
    formData.append("ckyc_consent_taken", true);
    // console.log(formData);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          const responseData = data.data?.data;
          if (responseData?.req_id) {
            sessionStorage.setItem("req_id", responseData.req_id);
          } else {
            toast.warning("Request Id is not found");
          }
        }
      });
  };
  handleOVDsubmirClick = (e) => {
    e.preventDefault();
    const { identicationtype, doc_type, OVD, proposer_fname, proposer_lname } =
      this.state;
    const customer_name = `${proposer_fname} ${proposer_lname}`;

    this.setState({ isOVDSubmitting: true });
    const OVDdata = {
      req_id: sessionStorage.req_id,
      proposal_no: this.state.proposal_no,
      id_type: identicationtype,
      doc_type: doc_type,
      customer_name: customer_name,
      doc_base64: OVD,
    };
    var formData = new FormData();
    const OVDdata1 = JSON.stringify(OVDdata);
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 368);
    formData.append("jsonData", JSON.stringify(OVDdata1));
    formData.append("savedata", "yes");
    // console.log(formData);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          this.setState({ ckycSuccess: true, isOVDVerified: true });
          sessionStorage.setItem("req_id", this.state.req_id);
          sessionStorage.setItem("ovdrequestId", data.requestId);
          setTimeout(() => {
            this.setState({ isOVDSubmitting: false });
            this.handleOVDRequestResponse();
          }, 20000);
        }
      })
      .catch((err) => {
        alert.error("OVD Faild to Upload file");
        this.setState({ isOVDSubmitting: false });
      });
  };
  handleOVDRequestResponse = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 368);
    formData.append("requestId", sessionStorage.ovdrequestId);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.data?.data;
        if (responseData?.clientId) {
          this.setState({ isCKYCdone: true });
          sessionStorage.setItem("traceId", responseData.traceId);
          sessionStorage.setItem("clientId", responseData.clientId);
        }
      });
  };
  handleOVDChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1]; // Remove data:image/...;base64,
        this.setState({ OVD: base64String }); // Save base64 string
      };
      reader.readAsDataURL(file); // Convert file to base64
    }
  };
  handledoc_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      doc_type: fieldValue,
    });
  };
  handlecustomer_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ customer_name: fieldValue });
  };
  handleproposer_lnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_lname: fieldValue });
  };
  handleproposer_mnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_mname: fieldValue });
  };
  handleproposer_fnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ proposer_fname: fieldValue });
  };
  handleAadhaarSubmitClick = (e) => {
    e.preventDefault();
    const { aadharNumber, identicationtype, gender, dob } = this.state;
    const fullAadhaar = aadharNumber.join("");
    if (fullAadhaar.trim() === "") {
      this.showToast("Aadhaar number is required.", "error");
      return;
    }
    if (gender.trim() === "") {
      this.showToast("Select Gender is required.", "error");
      return;
    }
    if (!dob || dob.trim() === "") {
      this.showToast("Enter  DOB is required.", "error");
      return;
    }
    const aadhaarRegex = /^\d{12}$/;
    if (!aadhaarRegex.test(fullAadhaar)) {
      this.showToast(
        "Aadhaar must be 12 digits long and contain only numbers.",
        "error"
      );
      return;
    }
    const formattedDOB = dob.includes("-")
      ? dob.split("-").reverse().join("-")
      : dob;

    const aAdhaarJsonData = {
      proposal_no: this.state.proposal_no,
      id_num: fullAadhaar,
      id_type: identicationtype,
      req_id: sessionStorage.proposalrequest_Id,
      gender: gender,
      dob: formattedDOB,
    };
    this.setState({ isAadhaarSubmitting: true });
    const aadharjsonData = JSON.stringify(aAdhaarJsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 349);
    formData.append("requestId", sessionStorage.proposalrequest_Id);

    formData.append("jsonData", JSON.stringify(aadharjsonData));
    formData.append("savedata", "yes");
    // console.log(formData);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("req_id", this.state.req_id);
          //sessionStorage.setItem("clientId", this.state.clientId);
          sessionStorage.setItem("aadhaarrequestId", data.requestId);
          this.setState({ showOtpInput: true });
          setTimeout(() => {
            this.handleAadharRequestResponse();
            this.setState({ isAadhaarSubmitting: false });
          }, 20000);
        }
      })
      .catch((err) => {
        alert.error("Aadhaar Failed Submit"); // ✅ use toast.error
        this.setState({ isAadhaarSubmitting: false });
      });
  };
  handleAadharRequestResponse = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 349);
    formData.append("requestId", sessionStorage.aadhaarrequestId);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.data?.data;
        if (responseData?.clientId) {
          sessionStorage.setItem("clientId", responseData.clientId);
        } else {
          toast.warning("Client Id is not found");
        }
      })
      .catch((err) => {
        toast.error("Failed to retrieve proposal data.");
      });
  };
  handleFORM60Change = (e) => {
    e.preventDefault();
    const files = e.target.files[0];
    this.setState({ Form60: files });
  };
  handleaadharnumberChange = (index, value) => {
    const cleanValue = value.replace(/\D/g, "").slice(0, 4); // Only digits, max 4
    const updated = [...this.state.aadharNumber];
    updated[index] = cleanValue;
    this.setState({ aadharNumber: updated }, () => {
      if (
        cleanValue.length === 4 &&
        index < this.state.aadharNumber.length - 1
      ) {
        const nextInput = document.getElementById(`aadharNumber-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    });
  };
  handleKeyDownAadharNumber = (idx, e) => {
    if (e.key === "Backspace" && !this.state.aadharNumber[idx] && idx > 0) {
      document.getElementById(`aadharNumber-${idx - 1}`).focus();
    }
  };
  handlegenderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      gender: fieldValue,
    });
  };
  handleOtpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      // allow only single digit or empty
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.otp];
          newOtp[index] = val;
          return { otp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput${index + 1}`].focus();
          }
        }
      );
    }
  };
  handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.otp[index] && index > 0) {
      this[`otpInput${index - 1}`].focus();
    }
  };
  HandelOTPSubmit = (e) => {
    e.preventDefault();
    const { aadharNumber, identicationtype } = this.state;
    const fullAadhaar = aadharNumber.join("");
    const otp = this.state.otp.join("");
    const aAdhaarOTP = {
      client_id: sessionStorage.clientId,
      proposal_no: this.state.proposal_no,
      id_num: fullAadhaar,
      id_type: identicationtype,
      otp: otp,
    };
    const aadhaarJsonData = JSON.stringify(aAdhaarOTP);
    this.setState({ isAadhaarOTPSubmitting: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("savedata", "yes");
    formData.append("integId", 366);
    formData.append("jsonData", JSON.stringify(aadhaarJsonData));
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("aadhaarotprequestId", data.requestId);
          this.setState({ isCKYCdone: true });
          setTimeout(() => {
            this.setState({ isAadhaarOTPSubmitting: false });
            this.handleVerifiyAadhaarResponse();
          }, 20000);
        }
      })
      .catch((err) => {
        alert.error("Aadhaar OTP Faild");
        this.setState({ isAadhaarOTPSubmitting: false });
      });
  };
  handleVerifiyAadhaarResponse = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 366);
    formData.append("requestId", sessionStorage.aadhaarotprequestId);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const responseData = data.data?.data;
        if (responseData?.traceId) {
          sessionStorage.setItem("traceId", responseData.traceId);
          sessionStorage.setItem("clientId", responseData.clientId);
        }
        if (responseData?.ckycSuccess === true) {
          this.setState({ isAadhaarVerified: true });
        }
      });
  };
  // HandleNext = (e) => {
  //   e.preventDefault();
  //   window.location = "./mpolicydownload";
  // };
  HandlePayment = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 362);
    formData.append("requestId", sessionStorage.proposalPaymentrequest_Id);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message_txt || data.message, true);

        if (
          data.status === "success" &&
          data.data?.status === 200 &&
          data.data?.data
        ) {
          try {
            const parsedInnerData = JSON.parse(data.data.data); // ✅ Parse this nested string
            const paymentUrl = parsedInnerData?.url;

            if (paymentUrl) {
              sessionStorage.setItem(
                "paymentverificationrequestId",
                data.requestId
              );
              window.location.href = paymentUrl;
            }
          } catch (err) {

          }
        }
      })
      .catch((error) => {

        toast.error("Something went wrong while initiating payment.");
      });
  };
  render() {
    const {
      id_type,
      id_num,
      identicationtype,
      aadharNumber,
      gender,
      dob,
      showOtp,
      otp,
      doc_type,
      proposal_no,
      showOtpInput,
      isCKYCdone,
      showVerification,
    } = this.state;

    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0); // Set the month to January
    previousYearStart.setDate(1); // Set the date to the first day of January

    // Example end year
    const endYear = new Date();
    endYear.setFullYear(endYear.getFullYear() + 10);

    return (
      <div className="bgalphacolor">
        <h3 className="logoskybluecolor">KYC</h3>
        <Row className="mb-3">
          <Col className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid fill nav-icon">
              <p className="nav-label mt-2">Vehicle Details</p>
            </div>
          </Col>

          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Quotes</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Vehicle Info</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">KYC</p>
            </div>
          </Col>
        </Row>
        <Row className="m-0">
          <div className="widget_BG">
            <Form>
              <div className="col-md-4">
                <Form.Label>Proposal Name</Form.Label>
                <Form.Control
                  name="proposal_no"
                  className="form-control"
                  value={proposal_no}
                  maxLength={10}
                  placeholder="Enter PAN Number"
                  onChange={this.handlePanChange}
                />
              </div>
              <div className="col-md-4">
                <Form.Label> Identity Proof: </Form.Label>
                <Form.Select
                  name="id_type"
                  value={id_type}
                  onChange={this.handleChange}
                  aria-label="Default select example"
                  className="form-control"
                  id="idTYPE"
                >
                  <option selected>Select Identity Type</option>
                  <option value="PAN">PAN Card</option>
                </Form.Select>
              </div>
              <div className="col-md-4">
                <Form.Label> PAN No</Form.Label>
                <Form.Control
                  name="id_num"
                  className="form-control"
                  value={id_num}
                  maxLength={10}
                  placeholder="Enter PAN Number"
                  onChange={this.handlePanChange}
                />
              </div>

              <Button
                id="getQuotes4"
                type="submit"
                onClick={this.HandlePansubmit}
                disabled={this.state.ispanSubmitting}
                style={{ float: "right" }}
                className="rounded-0 mt-4"
              >
                {this.state.ispanSubmitting
                  ? "Submitting... Please Wait"
                  : "Pan Submit"}
              </Button>
            </Form>
          </div>
        </Row>
        {showVerification && (
          <Row className="m-0 mt-1">
            <div className="widget_BG">
              <Form>
                <div className="col-md-4">
                  <Form.Label>Select Id Type</Form.Label>
                  <Form.Select
                    name="identicationtype"
                    value={identicationtype}
                    onChange={this.handleidenticationtypeChange}
                    aria-label="Default select example"
                    className="form-control"
                    id="identicationtype"
                  >
                    <option selected>Select Identity Type</option>
                    <option value="AADHAAR">AADHAAR</option>
                    <option value="OVD">OVD</option>
                    {/* // <option value="Form60">Form60</option> */}
                  </Form.Select>
                </div>
              </Form>
            </div>

            {identicationtype === "OVD" && (
              <div className="widget_BG">
                <>
                  <div className="col-md-4">
                    <Form.Label>OVD</Form.Label>
                    <Form.Control
                      accept=".jpg,jpeg,.png"
                      type="file"
                      onChange={this.handleOVDChange}
                      className="form-control"
                      name="OVD"
                      required="required"
                    />
                  </div>

                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="proposer_fname"
                        id="proposer_fname"
                        value={this.state.proposer_fname}
                        onChange={this.handleproposer_fnameChange}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="proposer_lname"
                        id="proposer_lname"
                        value={this.state.proposer_lname}
                        onChange={this.handleproposer_lnameChange}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Label> Document Type </Form.Label>
                    <Form.Select
                      name="doc_type"
                      value={doc_type}
                      onChange={this.handledoc_typeChange}
                      aria-label="Default select example"
                      className="form-control"
                      id="doc_type"
                    >
                      <option selected>Select Document Type</option>
                      <option value="image">Image</option>
                    </Form.Select>
                  </div>

                  <Button
                    type="submit"
                    onClick={this.handleOVDsubmirClick}
                    style={{ float: "right" }}
                    className="rounded-0 mt-4"
                    disabled={this.state.isOVDSubmitting}
                  >
                    {this.state.isOVDSubmitting
                      ? "Submitting... Please Wait"
                      : "OVD File"}{" "}
                  </Button>
                </>
              </div>
            )}

            {identicationtype === "AADHAAR" && (
              <div className="widget_BG">
                <>
                  <div className="row">
                    <div className="col-md-4">
                      <Form.Label>AADHAAR Number</Form.Label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {aadharNumber.map((val, idx) => (
                          <Form.Control
                            id={`aadharNumber-${idx}`}
                            className="formselect"
                            style={{
                              textAlign: "center",
                            }}
                            type="text"
                            maxLength={4}
                            value={val}
                            onChange={(e) =>
                              this.handleaadharnumberChange(idx, e.target.value)
                            }
                            tabIdx={idx + 1}
                            onKeyDown={(e) =>
                              this.handleKeyDownAadharNumber(idx, e)
                            }
                          />
                        ))}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <Form.Label>Gender</Form.Label>
                      <Form.Select
                        name="gender"
                        className="form-control"
                        value={gender}
                        onChange={this.handlegenderChange}
                      >
                        <option selected>Select Gender</option>
                        <option value="M">MALE</option>
                        <option value="F">FEMALE</option>
                      </Form.Select>
                    </div>
                    <div className="col-md-4">
                      <Form.Label className="form-label">DOB:</Form.Label>

                      <div calendarClassName="custom-calendar">
                        <DatePicker
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                          showTimeSelect={false}
                          selected={dob}
                          onChange={(date) => this.handleDChange(date)}
                          className="form-control"
                          id="dob"
                          placeholderText="Select Date of Birth"
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          minDate={previousYearStart} // Set the minimum selectable date
                          maxDate={new Date()} // Set the maximum selectable date
                        />
                      </div>
                      <Button
                        id="getQuotes4"
                        type="submit"
                        onClick={this.handleAadhaarSubmitClick}
                        style={{ float: "right" }}
                        disabled={this.state.isAadhaarSubmitting}
                        className="rounded-0 mt-4"
                      >
                        {this.state.isAadhaarSubmitting
                          ? "Submitting... please Wait"
                          : "Aadhaar Submit"}{" "}
                      </Button>
                    </div>
                  </div>
                  {showOtpInput && (
                    <div className="row mt-2">
                      <div className="col-md-6 d-flex gap-2 ">
                        <Form.Label className="d-block mb-2">OTP</Form.Label>

                        {otp.map((digit, index) => (
                          <Form.Control
                            key={index}
                            name="otp"
                            id="otp"
                            type={showOtp ? "text" : "password"}
                            maxLength="1"
                            value={digit}
                            onChange={(e) => this.handleOtpChange(e, index)}
                            onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                            ref={(input) => (this[`otpInput${index}`] = input)}
                            style={{
                              width: "40px",
                              height: "40px",
                              fontSize: "18px",
                              borderRadius: "4px",
                            }}
                            className="form-control"
                          />
                        ))}
                        <Button
                          variant="outline-secondary"
                          className={`rounded-0 bi ${showOtp ? "bi-eye-slash" : "bi-eye"
                            }`}
                          style={{
                            width: "40px",
                            height: "40px",
                            fontSize: "18px",
                            borderRadius: "4px",
                          }}
                          onClick={() => this.setState({ showOtp: !showOtp })}
                        />
                        <Button
                          variant="primary"
                          className="rounded-0 "
                          onClick={this.HandelOTPSubmit}
                          disabled={this.state.isAadhaarOTPSubmitting}
                        >
                          {this.state.isAadhaarOTPSubmitting
                            ? "Submitting... Please Wait"
                            : "Submit Aadhaar OTP"}
                        </Button>
                      </div>
                    </div>
                  )}
                </>
              </div>
            )}
          </Row>
        )}
        {true && ( // always shows Paynow for testing
          <Row className="m-0 mt-1">
            <div className="widget_BG">
              <Col>
                <Button
                  style={{ float: "right" }}
                  variant="primary"
                  className="rounded-0"
                  onClick={this.HandlePayment}
                >
                  Paynow{" "}
                </Button>
              </Col>
            </div>
          </Row>
        )}
      </div>
    );
  }
}
